import { useState } from "react";

export const useErrorBoundary = () => {
  const [error, setError] = useState<Error | null>(null);

  const handleError = (err: Error) => {
    setError(err);
  };

  if (error) {
    throw error;
  }

  return handleError;
};
